import { createAsyncThunk } from '@reduxjs/toolkit';
import { login } from 'services/authorization/authorization.service';
import { ILoginRequestPayload, ILoginResponse } from 'services/authorization/types';

export const ThunkLogin = createAsyncThunk<ILoginResponse, ILoginRequestPayload>(
  'authorization/login',
  payload => login(payload).then(res => res.data),
);
